var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGritLongIslandEast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.2 36.46v7.75H76.75l-6.23 52.4a3.852 3.852 0 01-3.74 3.4h-.1c-1.88 0-3.5-1.35-3.8-3.22L50.7 24.23 40.09 72.66a3.855 3.855 0 01-3.72 3.03c-1.8-.02-3.38-1.17-3.82-2.91l-9.73-38.75-6.11 15.98c-.57 1.5-2 2.49-3.62 2.49H2.11v-7.75h8.33l9.54-24.91a3.906 3.906 0 013.84-2.49c1.68.1 3.11 1.29 3.52 2.93l8.7 34.66L47.45 3.05A3.858 3.858 0 0151.21 0h.1a3.89 3.89 0 013.72 3.24l11 65.62 3.44-28.98c.24-1.94 1.88-3.42 3.84-3.42H96.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGritLongIslandEast);
export default __webpack_public_path__ + "static/media/Grit_LongIslandEast.423b5915.svg";
export { ForwardRef as ReactComponent };